module.exports = __webpack_public_path__ + "static/media/Johan&Carma(121).2572049a.jpg";